
var stache = require('can/view/stache/stache');
module.exports = stache("<tournament-hills {qualifying-status}=\"qualifyingStatus\" {logo-image}=\"logoImage\" {competition-title}=\"competitionTitle\" {location}=\"location\" />\r\n");